var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.MIX_getCurrentUser().userType === 'Staff')?_c('parking-admin'):_vm._e(),(_vm.MIX_getCurrentUser().userType === 'Steward')?_c('parking-steward'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }